import http from "./http";
import { buildUrlFromLocation } from "@/utils/httpUtils";
import cacheService from "@/services/cache";

export default {
    /**
     *
     * @returns {String}
     */
    async asPdf({ planoId, name, svg, campaignName, zoneName, campaignId, zoneId, brandId, width, height }) {
        console.assert(typeof name === "string");
        console.assert(typeof campaignName === "string");
        console.assert(typeof zoneName === "string");
        console.assert(typeof brandId === "number");
        console.assert(typeof zoneId === "number");
        console.assert(typeof width === "number");
        console.assert(typeof height === "number");
        console.assert(typeof campaignId === "number");
        console.assert(typeof planoId === "number");
        console.assert(svg instanceof Element);

        const response = await http.post(buildUrlFromLocation("/generate-svg-pdf", { campaignId, zoneId, brandId }), {
            name,
            pages: [
                {
                    content: `<svg  viewBox=\"${-width / 2} ${-height /
                        2} ${width} ${height}\" width=\"95%\" height=\"95%\" style=\"margin: auto; display: block;\" >${svg.innerHTML}</svg>`,
                    campaign: campaignName,
                    pager: zoneName
                }
            ],
            campaign: campaignName,
            zone: zoneName
        });
        return response.url;
    },
    async multiPdf({ planoId, name, fileName, campaignName, zoneName, campaignId, zoneId, brandId, compressLevel, pages }) {
        console.assert(typeof name === "string");
        console.assert(typeof campaignName === "string");
        console.assert(typeof zoneName === "string");
        console.assert(typeof brandId === "number");
        console.assert(typeof zoneId === "number");
        console.assert(typeof campaignId === "number");
        console.assert(typeof planoId === "number");
        //console.assert(svg instanceof Element);

        const response = await http.post(buildUrlFromLocation("/generate-svg-pdf", { campaignId, zoneId, brandId }), {
            name,
            pages,
            fileName,
            campaign: campaignName,
            zone: zoneName,
            compressLevel
        });
        return response.url;
    },
    async asXsl(planoId) {
        console.assert(typeof planoId === "number");
        const languageCode = cacheService.getUserLang() || "en";
        return http.get(buildUrlFromLocation(`/plano/${planoId}/export-excel?lang=${languageCode}`));
    }
};



// WEBPACK FOOTER //
// ./src/services/export.js